/* eslint-disable */
import React from 'react';

export const NotFound = () => (
  <div>
    <h1>404 - Oh no's! We couldn't find that page :(</h1>
  </div>
);
export default NotFound;
